module.exports = __webpack_public_path__ + "img/rakuten_btn.2148a88a.png";